import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';

import { UnitsState } from './types';

export default function initialState(): UnitsState {
  return {
    ...initialStateSubscribable(),
  };
}
